var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1467 5.61008V0H10.631V5.61008C9.40393 5.87902 8.4826 6.97461 8.4826 8.28125V9.41406H4.15811L3.74479 11.894C3.60424 12.7372 3.84057 13.5948 4.39311 14.2471C4.81713 14.7476 5.39131 15.0835 6.02167 15.2131V18.8281H4.4585V20H16.2951V8.28125C16.2951 6.97461 15.3738 5.87902 14.1467 5.61008ZM5.28729 13.4896C4.95784 13.1007 4.81694 12.5894 4.90073 12.0866L5.15085 10.5859H8.06436L8.31448 12.0866C8.39827 12.5894 8.25737 13.1007 7.92792 13.4896C7.59854 13.8785 7.11729 14.1016 6.6076 14.1016C6.09792 14.1016 5.61671 13.8785 5.28729 13.4896ZM8.4826 18.8281H7.19354V15.2131C7.66854 15.1155 8.11167 14.9009 8.4826 14.5866V18.8281ZM11.8029 1.17188H12.9748V2.34375H11.8029V1.17188ZM15.1232 18.8281H9.65448V8.28125C9.65448 7.41969 10.3554 6.71875 11.217 6.71875H11.8029V3.51562H12.9748V6.71875H13.5607C14.4223 6.71875 15.1232 7.41969 15.1232 8.28125V9.41406H12.3889V16.0547H15.1232V18.8281ZM15.1232 14.8828H13.5607V10.5859H15.1232V14.8828Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.bea256113be882ec0fb91fa38dc80273.svg";
export { ForwardRef as ReactComponent };